(() => {
  const initCarousel = (carousel) => {
    if (!carousel || carousel.dataset.xeniaCarouselReady === 'true') return;
    carousel.dataset.xeniaCarouselReady = 'true';
    const track = carousel.querySelector('[data-xenia-carousel-track]');
    const slides = [...carousel.querySelectorAll('[data-xenia-carousel-slide]')];
    const prev = carousel.querySelector('[data-xenia-carousel-prev]');
    const next = carousel.querySelector('[data-xenia-carousel-next]');
    const dots = [...carousel.querySelectorAll('.xenia-card-carousel__dot')];
    if (!track || slides.length < 2) return;

    let index = 0;
    let pointerDownX = null;
    let dragged = false;

    const setIndex = (newIndex, doScroll = true) => {
      index = Math.max(0, Math.min(slides.length - 1, newIndex));
      if (doScroll) track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };

    prev?.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); setIndex(index - 1); });
    next?.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); setIndex(index + 1); });

    let scrollTimer;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const width = track.clientWidth || 1;
        setIndex(Math.round(track.scrollLeft / width), false);
      }, 70);
    }, { passive: true });

    track.addEventListener('pointerdown', (e) => { pointerDownX = e.clientX; dragged = false; }, { passive: true });
    track.addEventListener('pointermove', (e) => {
      if (pointerDownX !== null && Math.abs(e.clientX - pointerDownX) > 8) dragged = true;
    }, { passive: true });
    track.addEventListener('pointerup', () => { pointerDownX = null; setTimeout(() => { dragged = false; }, 0); }, { passive: true });
    track.addEventListener('click', (e) => { if (dragged) { e.preventDefault(); e.stopPropagation(); } }, true);

    setIndex(0, false);
  };

  const scan = (root = document) => root.querySelectorAll('[data-xenia-card-carousel]').forEach(initCarousel);
  const boot = () => scan(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
  new MutationObserver((mutations) => {
    if (mutations.some((m) => m.addedNodes.length)) scan(document);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
